import { PasswordUpdateFacade } from "./password-update.facade";

export { PasswordUpdateFacade };

export default [PasswordUpdateFacade];
